import React, { createContext, useEffect, useState } from 'react';
import { endpoints } from 'src/utils/axios';
import { postRequestSubmittal } from 'src/services';
import GeneratedSubmittal from './SideCards/submittals/generated-submittals';
import { useBoolean } from 'src/hooks/use-boolean';

export const StatusContext = createContext(null);

const SubmittalsStatusProvider = ({ children }) => {
  const generate = useBoolean();
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [fetchSubmittals, setFetchSubmittals] = useState(0);
  const [isAiFilepending, setIsAiFilepending] = useState(true);
  const [notification, setNotification] = useState(null);

  const checkStatus = async (batch_id) => {
    localStorage.setItem('batch_id', batch_id);
    localStorage.setItem('expire_time', Date.now() + 24 * 60 * 60 * 1000);
    checkPdfStatus(batch_id);
  };

  const checkPdfStatus = async (batch_id) => {
    try {
      const pdfData = await postRequestSubmittal(
        endpoints.submittals.submittals.pdf_status,
        { user_id: localStorage.getItem('userId'), batch_id },
        false
      );

      if (pdfData.status === 'in_progress') {
        setTimeout(() => checkPdfStatus(batch_id), 180000);
        console.log('Processing in progress...');
        if (!isAiFilepending) {
          setIsAiFilepending(true);
        }
      } else if (pdfData.status === 'completed') {
        setFileUrl(pdfData.combined_csv_download_url);
        const response = await fetch(pdfData.combined_csv_download_url);
        const blob = await response.blob();
        const originalName = pdfData.combined_csv ? pdfData.combined_csv.split('.')[0] : 'file';
        const file = new File([blob], `${originalName}.csv`, { type: 'text/csv' });

        console.log(file);
        setFile(file);
        generate.onTrue();
        resetFileProgress();
        setNotification({
          isUnRead: true,
          title: 'Processing completed successfully. AI file has been generated',
        });
      }
    } catch (error) {
      console.error('Error checking status:', error);
    }
  };

  useEffect(() => {
    const expireTime = Number(localStorage.getItem('expire_time'));
    const batchId = localStorage.getItem('batch_id');
    console.log(expireTime);
    console.log(Date.now());
    if (batchId && expireTime && Date.now() < expireTime) {
      checkPdfStatus(batchId);
    } else {
      resetFileProgress();
    }
  }, []);

  const resetFileProgress = () => {
    localStorage.removeItem('batch_id');
    localStorage.removeItem('expire_time');
    setIsAiFilepending(false);
  };

  console.log('isAiFilepending', isAiFilepending);

  return (
    <StatusContext.Provider
      value={{
        checkStatus,
        isAiFilepending,
        notification,
        setNotification,
        fetchSubmittals,
        setFetchSubmittals,
      }}
    >
      {children}
      <GeneratedSubmittal
        file={file}
        fileUrl={fileUrl}
        open={generate.value}
        onClose={generate.onFalse}
        reload={() => {}}
        closeform={() => generate.onFalse()}
      />
    </StatusContext.Provider>
  );
};

export default SubmittalsStatusProvider;
